import { CSSProperties, type ElementType, PropsWithChildren } from 'react';

import { SbComponentType, sbEditable } from '../../../utils';

interface CustomCSSProperties extends CSSProperties {
  '--bg-sb-color'?: string;
}

interface UniversalComponentProps extends PropsWithChildren {
  className?: string;
  tag?: ElementType | string;
  blok: SbComponentType<string>;
  style?: CustomCSSProperties;
}

export const UniversalComponent = ({
  children,
  className,
  blok,
  style,
  tag: Comp = 'div',
}: UniversalComponentProps) => (
  <Comp style={style} className={className} {...sbEditable(blok)}>
    {children}
  </Comp>
);
